// 引入组件开头使用大写C开头避免跟原生组件冲突
import Cyear from './year/index.vue'
import Ccheck from './check/index.vue'
import Cdate from './date/index.vue'
import CdateTime from './dateTime/index.vue'
import Ceditor from './editor/index.vue'
import Cinput from './input/index.vue'
import Cpassword from './password/index.vue'
import Cslider from './slider/index.vue'
import Cnumber from './number/index.vue'
import Cradio from './radio/index.vue'
import defaultSelector from './select/index.vue'
import StaffSelector from './select/StaffSelector.vue'
import TeamSelector from './select/TeamSelector.vue'
import WorkerSelector from './select/WorkerSelector.vue'
import CuserSelectorMultiple from './select/UserSelectorMultiple.vue'
import UserSelector from './select/UserSelector.vue'
import SiteSelector from './select/SiteSelector.vue'
import Cswitch from './switch/index.vue'
import Ctextarea from './textarea/index.vue'
import Cupload from './upload/index.vue'
import Ctime from './time/index.vue'
import Cmonth from './month/index.vue'
import CmonthNew from './monthNew/index.vue'
import Ccheckbox from './checkbox/index.vue'
import CdateRange from './dateRange/index.vue'
import CdateRangeNoTime from './dateRange/dateNoTime.vue'
import CmonthRange from './monthRange/index.vue'
import Cinfo from './info/index.vue'
import Ctitle from './title/index.vue'
import Ctable from './table/index.vue'
import AeesssmentSelect from './select/selectAeeseement.vue'

export default {
  Cyear,
  Ccheck,
  Cdate,
  CdateTime,
  CmonthRange,
  Ceditor,
  Cinput,
  Cpassword,
  Cslider,
  Cnumber,
  Cradio,
  defaultSelector,
  CuserSelectorMultiple,
  StaffSelector,
  TeamSelector,
  AeesssmentSelect,
  Cswitch,
  Ctextarea,
  Cupload,
  Ctime,
  Cmonth,
  CmonthNew,
  Ccheckbox,
  CdateRange,
  CdateRangeNoTime,
  WorkerSelector,
  UserSelector,
  SiteSelector,
  Cinfo,
  Ctitle,
  Ctable,
}
